import { setProgressBarDisplay } from "../services/setProgressBarDisplay";
import {$} from "../third-party-imports";
import { getRefDetails } from "../util";

export function leadFlowTechAvailabiltyFail(brand:any){
    $('.tab-pane.fieldset').removeClass('active');
    window.objOSGlobal.requestBodyValues.IsLeadOnly = true;
    window.objOSGlobal.requestBodyValues.ScheduleId = ''
     switch(brand){
        case '1':
        getRefDetails();
        $('#schedulerWizard #about-home-screen').addClass('active');
        break;
        case '8':
        window.objOSGlobal.requestBodyValues.Warranty = true;
        leadflowScenario(brand);
        break;
        default:
        leadflowScenario(brand);
     }
}

function leadflowScenario(code:any){
    $('.progressbar a[data-step="calendar-screen"]').parent().hide();
    $('#schedulerWizard #contact-information-screen').addClass('active');
    $('#js-schedulerDialog .modal-header-two .result-stack-logo, #js-schedulerDialog .modal-header-two #modal-header-contact').removeClass('hidden');
    $('#schedulerWizard #contact-information-screen').addClass('active');
    setProgressBarDisplay(code, window.objOSGlobal.requestBodyValues.IsLeadOnly);
}